<template>
  <b-container>
    <h4 class="py-2 mt-4">
      <span class="mark-bottom">購物車</span>
    </h4>
    <b-row class="mt-3">
      <b-col cols="12">
        <b-table :busy="isBusy" :items="list" :fields="fields" show-empty head-variant="light" outlined>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty>
            <b-jumbotron bg-variant="light" fluid class="border text-center mb-0">
              <template v-slot:header>您尚未添加商品至購物車中</template>
              <hr class="my-4">
              <p class="text-center pt-5">
                <font-awesome-icon icon="shopping-cart" class="text-secondary fs-16"/>
              </p>
            </b-jumbotron>
          </template>
          <template v-slot:cell(info)="scope">
            <b-row no-gutters>
              <!--b-col md="6">
                <b-card-img lazy :src="scope.item.pic" class="rounded-0" :alt="scope.item.name"></b-card-img>
              </b-col-->
              <b-col md="12" class="pt-1">
                <b-link :to="`/prod/${scope.item.cid}`" target="_blank">
                  <h6 class="my-2">{{scope.item.name}}</h6>
                </b-link>
                <!--p class="my-2">{{scope.item.descript}}</p-->
              </b-col>
            </b-row>
          </template>
          <template v-slot:cell(amount)="scope">
            <b-input-group class="p-1">
              <template v-slot:prepend>
                <b-button @click="onClickChangeItemAmount(scope.item.id, -1)" variant="warning" class="border">
                  <font-awesome-icon icon="minus" size="sm"></font-awesome-icon>
                </b-button>
              </template>
              <b-form-input
                :id="`buy-amount-${scope.item.id}`"
                v-model="scope.item.amount"
                required
                type="number"
                min="1"
                class="text-center"
                @change="onClickChangeItemAmount(scope.item.id)"
              ></b-form-input>
              <template v-slot:append>
                <b-button @click="onClickChangeItemAmount(scope.item.id, 1)" variant="success" class="border">
                  <font-awesome-icon icon="plus" size="sm"></font-awesome-icon>
                </b-button>
              </template>
            </b-input-group>
          </template>
          <template v-slot:cell(totally)="scope">
            $ {{scope.item.price * scope.item.amount}}
          </template>
          <template v-slot:cell(ops)="scope">
            <b-button variant="danger" @click="onClickRemoveItem(scope.item.id)">
              <font-awesome-icon icon="times"/>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <hr>
    <div class="text-right">
      <b-button class="mr-3" variant="secondary" size="md" @click="rollBack">繼續選購</b-button>
      <b-button v-if="isEmpty" to="/" size="md" class="btn-pur-dark">返回首頁</b-button>
      <b-button v-else to="/checkout" size="md" class="btn-pur-dark">立即結帳</b-button>
    </div>
  </b-container>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faShoppingCart, faTimes, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
library.add(faShoppingCart, faTimes, faPlus, faMinus)
export default {
  name: 'cart',
  data () {
    return {
      isBusy: false,
      list: []
    }
  },
  computed: {
    isEmpty () {
      return this.list.length === 0
    },
    fields () {
      return [
        { key: 'info', label: '商品', thStyle: 'width: 40%' },
        { key: 'size', label: '規格' },
        { key: 'price', label: '單價' },
        { key: 'amount', label: '數量', thStyle: 'width: 20%' },
        { key: 'totally', label: '小計' },
        { key: 'ops', label: '刪除', thStyle: 'width: 4rem' }
      ]
    }
  },
  methods: {
    rollBack () {
      this.$router.back()
    },
    async fetch () {
      this.isBusy = true
      try {
        const { data } = await this.$api.getCart()
        const wait = data.map(async item => {
          const { id, catalog: cid, size: sid, amount } = item
          const { data: catalog } = await this.$api.getProd(cid)
          const findSize = catalog.size.find(item => item.id === sid)
          const pics = catalog.pics
          pics.sort((a, b) => a.sort - b.sort)
          const obj = { id, cid, amount, price: catalog.price, name: catalog.name, descript: catalog.description, sid }
          if (pics.length) {
            const [ firstPic ] = pics
            obj.pic = this.$api.catalogImageLink(cid, firstPic.id)
          }
          if (findSize) {
            obj.size = findSize.name
          } else {
            obj.isError = true
          }
          return obj
        })
        this.list = await Promise.all(wait)
      } catch (err) {
        console.log(err)
      }
      this.isBusy = false
    },
    async onClickChangeItemAmount (id, n) {
      const find = this.list.find(item => item.id === id)
      if (n) {
        // button
        let val = parseInt(find.amount) + n
        val = val > 0 ? val : 1
        this.$set(find, 'amount', val)
      }
      const { cid, sid, amount } = find
      const cargo = { catalog: cid, size: sid, amount: amount }
      await this.$api.putCart({ cargo })
    },
    async onClickRemoveItem (id) {
      const item = this.list.find(item => item.id === id)
      const { cid, sid } = item
      const cargo = { catalog: cid, size: sid, amount: 0 }
      await this.$api.putCart({ cargo })
      this.fetch()
      this.$bus.$emit('update:cart')
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>
<style>
  .fs-16 {
    font-size: 16rem;
  }
  .table td {
    line-height: 46px;
  }
</style>